export default {
  subject: 90,
  message: 6000,
};
